import { PoolPointData } from 'apps/sigma2-ui/src/copilot/components/PoolPointData';

export type TooltipPosition =
  | 'bottom_left'
  | 'bottom_middle'
  | 'bottom_right'
  | 'middle_left'
  | 'middle_middle'
  | 'middle_right'
  | 'top_left'
  | 'top_middle'
  | 'top_right';

export const determineTooltipPosition = (parameters: {
  yMin: number;
  yMax: number;
  xMin: number;
  xMax: number;
  data: PoolPointData;
}): TooltipPosition => {
  let tooltipPosition: TooltipPosition;
  let yLocation: 'top' | 'middle' | 'bottom';
  const { yMin, yMax, xMin, xMax, data } = parameters;
  const yPoint = data.y as number;
  const xPoint = data.x as number;
  const yRatio = (yPoint - yMin) / (yMax - yMin);
  const xRatio = (xPoint - xMin) / (xMax - xMin);

  if (yRatio <= yMax / 3) {
    yLocation = 'middle';
  } else if (yRatio >= (yMax * 2) / 3) {
    yLocation = 'middle';
  } else {
    yLocation = 'top';
  }

  let xLocation: 'left' | 'middle' | 'right';
  if (xRatio <= xMax / 3) {
    xLocation = 'middle';
  } else if (xRatio >= (xMax * 2) / 3) {
    xLocation = 'middle';
  } else {
    xLocation = 'left';
  }

  if (yLocation === 'top') {
    if (xLocation === 'left') {
      tooltipPosition = 'top_left';
    } else if (xLocation === 'middle') {
      tooltipPosition = 'top_middle';
    } else {
      tooltipPosition = 'top_right';
    }
  } else if (yLocation === 'middle') {
    if (xLocation === 'left') {
      tooltipPosition = 'middle_left';
    } else if (xLocation === 'middle') {
      tooltipPosition = 'middle_middle';
    } else {
      tooltipPosition = 'middle_right';
    }
  } else {
    if (xLocation === 'left') {
      tooltipPosition = 'bottom_left';
    } else if (xLocation === 'middle') {
      tooltipPosition = 'bottom_middle';
    } else {
      tooltipPosition = 'bottom_right';
    }
  }
  return tooltipPosition;
};
